var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"process-detail"},[_c('iframe',{staticClass:"detailUrl-page",attrs:{"src":_vm.detailUrl,"frameborder":"0"}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b1d43c2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/process/ProcessList/ProcessDetailView.vue
// module id = 1441
// module chunks = 137